module.exports = __webpack_public_path__ + "static/alum1-80af78f5e17c5f319967913572e9cf3e.png";